import { Outlet } from "react-router-dom";
import { MainLayout } from "@/components/MainLayout";

export default function SettingsLayout() {
  return (
    <MainLayout>
      <div className="w-full p-6">
        <Outlet />
      </div>
    </MainLayout>
  );
}
